module.exports = "/assets/data/b48e6ccfb14777cdb67463d992d0c19b-EN5.data.json";